// Contract: GOTU-8148 Candidate Details view rules — interview card status, order and copy.
// Sources: merged:TempMee/dental-portal@b68f1a1fc (OnsiteInterviewStatus values,
//          src/domain/PermanentJobs/enums/OnsiteInterviewStatus.ts);
//          merged:TempMee/mobile-app@6109e549b (adds 'pending', same enum path);
//          @tempmee/core DentalOfficeShiftCardStatus (dental-portal 3.0.0, mobile-app ^3.3.0);
//          ticket:GOTU-8148 ("Candidate Details");
//          assumed — Office Figma 6720:199436 (every other string, the status mapping).
// One file, two verbatim copies — change both together:
//   TempMee/dental-portal src/components/CandidateOverview/candidateDetailsView.ts
//   TempMee/mobile-app    src/components/CandidateOverview/candidateDetailsView.ts
import type { DentalOfficeShiftCardStatus } from '@tempmee/core';

export const CANDIDATE_DETAILS_COPY = {
  title: 'Candidate Details',
  interviewsHeading: 'All Onsite Interviews',
  inviteToInterview: 'Invite to interview',
  noInterviews: 'No onsite interviews yet.',
  addInterview: 'Add interview',
} as const;

/**
 * An onsite interview's status → the DS shift card's lifecycle state.
 *
 * Takes a plain string so this file needs no app imports; the two apps' enums
 * share these values. An unknown status reads as scheduled, the same fallback
 * `OnsiteInterviewStatusMapper.fromJobStatus` uses.
 */
export const toInterviewCardStatus = (status: string): DentalOfficeShiftCardStatus => {
  switch (status) {
    case 'action_needed':
    case 'pending':
      return 'confirm-candidates';
    case 'completed':
      return 'completed';
    case 'cancelled':
      return 'cancelled';
    case 'open':
      return 'open';
    default:
      return 'scheduled';
  }
};

/**
 * The candidate's interviews, newest first by `jobDatetime` (an ISO instant), so
 * the order never depends on the device's timezone. Ties fall back to the id to
 * keep the list stable between renders. Returns a copy.
 */
export const sortInterviewsNewestFirst = <
  T extends { jobDatetime: string; onsiteInterviewId: string },
>(
  items: readonly T[],
): T[] =>
  [...items].sort(
    (a, b) =>
      Date.parse(b.jobDatetime) - Date.parse(a.jobDatetime) ||
      a.onsiteInterviewId.localeCompare(b.onsiteInterviewId),
  );
